
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/governance/v3/proposal",
      function () {
        return require("private-next-pages/governance/v3/proposal/index.governance.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/governance/v3/proposal"])
      });
    }
  